import React, { Component } from 'react';
import { ACCESS_TOKEN_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY } from '../../services/ShieldAxiosClient.ts';
import { customFetchV2 } from '../../services/custom-fetch-v2.ts';

import LoadingModal from './LoadingModal.jsx';

const LOGOUT_ENDPOINT = '/sessions/me';

class LogoutRoute extends Component {
  componentDidMount() {
    this.logout();
  }

  logout = () => {
    customFetchV2(LOGOUT_ENDPOINT, {
      method: 'DELETE',
    })
      .then((response) => {
        if (!response.ok) {
          // eslint-disable-next-line no-console
          console.error('Unable to logout');
        }
        window.location.href = '/dashboard';
      }).finally(() => {
        window.localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
        window.localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
      });
  }

  render() {
    return (
      <div className="dashboard-settings">
        <div className="section">
          <LoadingModal open={true} />
        </div>
      </div>
    );
  }
}
export default LogoutRoute;
